const es = {
  header: {
    badge: "Guía Oficial de BotMix",
    title: "Programador de Estados",
    summary:
      "Automatiza y programa la publicación de Estados (Stories) en tus cuentas de WhatsApp conectadas. Publica imágenes, videos o textos con fecha y hora exacta para mantener activa tu presencia de marca.",
  },
  sections: [
    {
      id: "programacion_estados",
      title: "1. Programación de Estados",
      description:
        "Crea historias programadas con soporte para texto, imágenes y video.",
      items: [
        {
          id: "tipo_contenido",
          title: "Contenido Multimedia y Textos",
          definition:
            "Sube imágenes en alta calidad, videos cortos o textos con colores de fondo y tipografías para tus estados.",
        },
        {
          id: "calendario_estados",
          title: "Planificación en Calendario",
          definition:
            "Visualiza en formato de cuadrícula semanal o mensual la programación de tus historias para no dejar días sin presencia.",
        },
      ],
    },
    {
      id: "monitoreo_estados",
      title: "2. Estados y Conexiones",
      description:
        "Selección de números de WhatsApp y seguimiento de publicaciones realizadas.",
      items: [
        {
          id: "conexion_estados",
          title: "Conexión de WhatsApp",
          definition:
            "Elige la línea telefónica que publicará la historia. Requiere conexión activa en Baileys.",
        },
        {
          id: "estado_envio",
          title: "Control de Envío",
          definition:
            "Comprueba si el estado fue publicado exitosamente o reprograma publicaciones pendientes.",
        },
      ],
    },
  ],
};

const en = {
  header: {
    badge: "BotMix Official Guide",
    title: "Status Scheduler",
    summary:
      "Automate and schedule WhatsApp Status (Stories) across connected channels. Publish images, videos, and formatted text with exact scheduling to boost brand reach.",
  },
  sections: [
    {
      id: "programacion_estados",
      title: "1. Status Scheduling",
      description:
        "Create scheduled WhatsApp stories with multimedia and custom text captions.",
      items: [
        {
          id: "tipo_contenido",
          title: "Rich Media & Text Stories",
          definition:
            "Upload high-resolution images, short video clips, or text statuses with background styling.",
        },
        {
          id: "calendario_estados",
          title: "Calendar Planning",
          definition:
            "Review weekly or monthly schedule grids to maintain continuous engagement.",
        },
      ],
    },
    {
      id: "monitoreo_estados",
      title: "2. Channels & Status Auditing",
      description:
        "Select target phone channels and track post execution.",
      items: [
        {
          id: "conexion_estados",
          title: "Connected WhatsApp Line",
          definition:
            "Select the active WhatsApp channel that will publish the story. Requires active Baileys session.",
        },
        {
          id: "estado_envio",
          title: "Delivery Status",
          definition:
            "Audit published, pending, or failed stories with instant reschedule capabilities.",
        },
      ],
    },
  ],
};

const pt = {
  header: {
    badge: "Guia Oficial BotMix",
    title: "Agendador de Status",
    summary:
      "Automatize e agende a publicação de Status (Stories) nas suas contas de WhatsApp conectadas. Envie fotos, vídeos e textos na data e hora desejadas.",
  },
  sections: [
    {
      id: "programacion_estados",
      title: "1. Agendamento de Status",
      description:
        "Crie publicações de status programadas com suporte multimídia.",
      items: [
        {
          id: "tipo_contenido",
          title: "Fotos, Vídeos e Textos",
          definition:
            "Faça upload de mídias ou crie mensagens de texto formatadas para engajar seus contatos.",
        },
        {
          id: "calendario_estados",
          title: "Planejamento em Calendário",
          definition:
            "Acompanhe o cronograma semanal ou mensal para manter sua marca sempre visível.",
        },
      ],
    },
    {
      id: "monitoreo_estados",
      title: "2. Conexões e Histórico",
      description:
        "Escolha a linha que publicará e acompanhe o status de cada postagem.",
      items: [
        {
          id: "conexion_estados",
          title: "Linha do WhatsApp",
          definition:
            "Selecione o número responsável pela publicação. Requer sessão Baileys ativa.",
        },
        {
          id: "estado_envio",
          title: "Histórico de Envios",
          definition:
            "Verifique se o status foi publicado com sucesso ou reagende publicações pendentes.",
        },
      ],
    },
  ],
};

const fr = {
  header: {
    badge: "Guide Officiel BotMix",
    title: "Planificateur de Statuts",
    summary:
      "Automatisez et planifiez la publication de statuts (Stories) sur vos comptes WhatsApp. Diffusez des images, vidéos et textes à des heures précises.",
  },
  sections: [
    {
      id: "programacion_estados",
      title: "1. Planification des Statuts",
      description:
        "Créez des stories programmées avec prise en charge multimédia complète.",
      items: [
        {
          id: "tipo_contenido",
          title: "Médias et Textes",
          definition:
            "Téléchargez des photos, vidéos ou statuts textuels avec typographie soignée.",
        },
        {
          id: "calendario_estados",
          title: "Calendrier de Publication",
          definition:
            "Visualisez le planning hebdomadaire ou mensuel pour animer votre communauté en continu.",
        },
      ],
    },
    {
      id: "monitoreo_estados",
      title: "2. Canaux et Suivi",
      description:
        "Sélectionnez le compte expéditeur et contrôlez la bonne diffusion.",
      items: [
        {
          id: "conexion_estados",
          title: "Ligne WhatsApp",
          definition:
            "Choisissez la connexion active qui diffusera l'histoire.",
        },
        {
          id: "estado_envio",
          title: "État de Diffusion",
          definition:
            "Vérifiez les statuts envoyés ou reprogrammez les publications en attente.",
        },
      ],
    },
  ],
};

const ar = {
  header: {
    badge: "دليل BotMix الرسمي",
    title: "مجدول حالات واتساب (Status)",
    summary:
      "أتمتة وجدولة نشر حالات وقصص واتساب عبر حساباتك المتصلة. انشر الصور ومقاطع الفيديو والنصوص في الموعد المحدد لتعزيز التفاعل مع علامتك التجارية.",
  },
  sections: [
    {
      id: "programacion_estados",
      title: "1. جدولة الحالات",
      description:
        "إنشاء حالات واتساب مجدولة مدعومة بالنصوص والوسائط.",
      items: [
        {
          id: "tipo_contenido",
          title: "الوسائط والنصوص",
          definition:
            "رفع صور وفيديوهات قصيرة أو كتابة حالات نصية جذابة.",
        },
        {
          id: "calendario_estados",
          title: "تقويم النشر",
          definition:
            "مراجعة الجداول الأسبوعية والشهرية لضمان وجود مستمر لنشاطك.",
        },
      ],
    },
    {
      id: "monitoreo_estados",
      title: "2. القنوات والمتابعة",
      description:
        "تحديد خط واتساب المنفذ ومتابعة نتائج الإرسال.",
      items: [
        {
          id: "conexion_estados",
          title: "خط واتساب المتصل",
          definition:
            "اختر الرقم المسؤول عن نشر الحالة بحالة اتصال نشطة.",
        },
        {
          id: "estado_envio",
          title: "حالة الإرسال",
          definition:
            "مراجعة الحالات المنشورة بنجاح أو إعادة جدولة المنشورات المعلقة.",
        },
      ],
    },
  ],
};

export const STATUS_SCHEDULER_HELP_DATA = { es, en, pt, fr, ar };
export default STATUS_SCHEDULER_HELP_DATA;
